<template>
  <el-tooltip 
    placement="top"
    :content="content" 
    :disabled="!isOverflowed"
  >
    <span ref="text" class="ellipsis-text">{{ content }}</span>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: { type: String, default: '' }
  },
  data() {
    return {
      isOverflowed: false
    };
  },
  mounted() {
    this.checkOverflow();
    this.observer = new ResizeObserver(this.checkOverflow);
    this.observer.observe(this.$refs.text);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    checkOverflow() {
      const el = this.$refs.text;
      if (!el) return;
      void el.offsetWidth; // 强制重排
      this.isOverflowed = el.scrollWidth > el.clientWidth;
    }
  }
};
</script>

<style scoped>
.ellipsis-text {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 250px; 明确限制宽度 */
}
</style>